<template>
  <div :class="['iq-sidebar sidebar-default', { show: isSidebarOpen }]">

    <div class="iq-sidebar-logo d-flex align-items-end justify-content-center">
      <router-link to="/crear-contenido-curricula" class="header-logo">
        <img src="/img/eleva/eleva_blanco_full.png" alt="logo-eleva">
      </router-link>
      <div class="side-menu-bt-sidebar-1">
        <svg xmlns="http://www.w3.org/2000/svg" class="text-light wrapper-menu" width="30" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" @click="toggleSidebar">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
    </div>

    <div class="data-scrollbar" data-scroll="1" id="sidebar-scrollbar">
      <nav class="iq-sidebar-menu">
        <ul id="iq-sidebar-toggle" class="side-menu">

          <div v-for="(result, index) in resultSet" :key="index">
            <div v-for="(res, j) in result[`children`]" :key="j">
              <li class="sidebar-layout">
                <router-link :to="`${res.link}`" class="svg-icon"
                  :style="(checkActive(`${res.route_name}`) ? 'background-color: rgba(255, 255, 255, 0.2);border-radius: 5px;' : '')"
                  :title="res.text">

                  <b-img :src="res.icon"
                    :alt="res.text"></b-img>
                  <span class="ml-2 text-white text-menu">
                    {{ res.text }}
                  </span>
                </router-link>
              </li>
            </div>
          </div>

          <!-- Módulo de Escuelas - Solo para Admin -->
          <li 
            v-if="$store.getters.usuario && $store.getters.usuario.roles && $store.getters.usuario.roles.some(r => r.name === 'admin')"
            class="sidebar-layout">
            <router-link to="/escuelas" class="svg-icon"
              :style="(checkActive('escuelas') || checkActive('escuelas-crear') || checkActive('escuelas-editar') ? 'background-color: rgba(255, 255, 255, 0.2);border-radius: 5px;' : '')"
              title="Gestión de Escuelas">
              <i>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </i>
              <span class="text-white text-menu">Escuelas</span>
            </router-link>
          </li>
          
          <li  v-if="$store.getters.usuario && $store.getters.usuario.roles && $store.getters.usuario.roles.some(r => r.name === 'admin' || r.name === 'gestorEscolarEstudiante' || r.name === 'gestorEscolar')"
              class="sidebar-layout">
            <router-link :to="{ name: 'DashboardGraficas' }" class="svg-icon"
                         :style="(checkActive('DashboardGraficas') || checkActive('DashboardGraficas2') ? 'background-color: rgba(255, 255, 255, 0.2);border-radius: 5px;' : '')"
                         title="Dashboard gráficas">

              <i>
                <svg class="svg-icon" id="iq-ui-1" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                        style="stroke-dasharray: 97, 117; stroke-dashoffset: 0;"></path>
                </svg>
              </i>
              <span class="text-white">Dashboard gráficas</span>
            </router-link>
          </li>

          <li v-if="$store.getters.usuario.curricula === 1" class="sidebar-layout active">
            <router-link :to="{ name: 'CrearContenidoCurricula' }" class="svg-icon">
              <i>
                <b-img src="https://storage.googleapis.com/estudiolab-aprende-cloud-run/iconos/contenidoCurriculas2.svg"
                  alt=""></b-img>
              </i>
              <span class="text-white">Capacitación</span>
            </router-link>
          </li>

          <li class="sidebar-layout" v-if="escuelaIdUser && showKnowMoreMenu">
            <a href="#" v-b-toggle.ui class="svg-icon collapsed">
              <i>
                <svg class="svg-icon" id="iq-ui-1" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                    style="stroke-dasharray: 97, 117; stroke-dashoffset: 0;"></path>
                </svg>
              </i>
              <span class="text-white text-menu">Conoce más</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon iq-arrow-right arrow-active" height="14"
                width="15" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </a>          

            <b-collapse tag="ul" id="ui" class="submenu" accordion="my-accordion" :visible="checkActive(ui)">
              <li class="sidebar-layout active">
                <router-link :to="{ name: 'Programa' }" class="svg-icon">
                  <i>
                    <svg style="color: white !important;" class="svg-icon text-white" id="iq-ui-1-0"
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </i>
                  <span class="text-white">Programa</span>
                </router-link>
              </li>
              <li class="sidebar-layout active">
                <router-link :to="{ name: 'Calendario' }" class="svg-icon">
                  <i>

                    <svg class="svg-icon" id="iq-ui-1-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </i>
                  <span class="text-white">Calendario</span>
                </router-link>
              </li>
              <li class="sidebar-layout active">
                <router-link :to="{ name: 'CapNovedades' }" class="svg-icon">
                  <i class="">
                    <svg class="svg-icon" id="iq-ui-1-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                    </svg>
                  </i>
                  <span class="text-white">Novedades</span>
                </router-link>
              </li>
              <li class="sidebar-layout active">
                <router-link :to="{ name: 'Coaches' }" class="svg-icon">
                  <i class="">
                    <svg class="svg-icon" id="iq-ui-1-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="white">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </i>
                  <span class="text-white">Coaches</span>
                </router-link>
              </li>
              <li class="sidebar-layout active">
                <router-link :to="{ name: 'Faqs' }" class="svg-icon">
                  <i class="">
                    <svg class="svg-icon" id="iq-ui-1-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </i>
                  <span class="text-white">FAQs</span>
                </router-link>
              </li>
            </b-collapse>
          </li>

        </ul>
      </nav>
    </div>


  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'

export default {
  name: "SidebarStyle",
  props: {
    items: Array,
    variant: { type: String }
  },
  watch: {
    isSidebarOpen(newVal) {
      const mainContainer = document.getElementById('main-container');
      if (!mainContainer) return;

      if (newVal) {
        mainContainer.classList.add('body-pushed');
      } else {
        mainContainer.classList.remove('body-pushed');
      }
    }
  },
  data() {
    return {
      ruta_actual: this.$route.name,
      //escuelaIdUser: true,
      indice: 0,
      resultSet: [],
      homeurl: '',
      dashboards: ['layout.dashboard1', 'layout.dashboard2', 'layout.dashboard3', 'layout.customer', 'layout.product', 'layout.order', 'layout.calendar'],
      app: ['app.chat', 'app.todo'],
      charts: ['chart.amchart', 'chart.apexchart', 'chart.highchart', 'chart.morrischart',],
      user: ['app.user-profile', 'app.user-add', 'app.user-list'],
      ui: ['Ui.avatars', 'Ui.alerts', 'Ui.badges', 'Ui.breadcrumbs', 'Ui.buttons', 'Ui.button-groups', 'Ui.boxshadows', 'Ui.colors', 'Ui.cards', 'Ui.carousels', 'Ui.grids', 'Ui.helper-classes', 'Ui.images', 'Ui.list-groups', 'Ui.media-objects', 'Ui.modals', 'Ui.notifications'
        , 'Ui.paginations', 'Ui.popovers', 'Ui.progressbars', 'Ui.typographys', 'Ui.tabs', 'Ui.tooltips', 'Ui.Embed-videos'],
      auth: ['auth.login', 'auth.register', 'auth.recover-password', 'auth.confirm-mail', 'auth.lock-screen'],
      pricing: ['price.pay', 'price.pay2'],
      icon: ['icon.dripicon', 'icon.fontawsome', 'icon.lineawsome', 'icon.remixicon',],
      error: ['error.404', 'error.500'],
      formControls: ['controls.form-checkbox', 'controls.form-layout', 'controls.form-input', 'controls.form-radio', 'controls.form-switch', 'controls.form-textarea', 'controls.form-validation',],
      formWidget: ['widget.form-datepicker', 'widget.form-file-uploader', 'widget.form-quill',],
      table: ['table.basic-table', 'table.data-table', 'table.edit-table',],
      timeline: ['time.line', 'time.line1'],
      extraPages: ['price.pay', 'pages.maintenance', 'pages.comingsoon', 'pages.invoices', 'pages.subscribers', 'pages.faq', 'pages.blank-page', 'pages.icon'],
      pages: [],      
    }
  },
  mounted() {
    this.getMenu();
    core.SmoothScrollbar()
    const urlParams = new URLSearchParams(window.location.search);
    const sidebar = urlParams.get('sidebar');
    if (sidebar !== null) {
      this.variant = ''
      switch (sidebar) {
        case "0":
          this.variant = 'sidebar-dark'
          break;
        case "1":
          this.variant = 'sidebar-light'
          break;
        default:
          this.variant = ''
          break;
      }
    }

    const mainContainer = document.getElementById('main-container');
    if (mainContainer && this.isSidebarOpen) {
      mainContainer.classList.add('body-pushed');
    }
  },
  destroyed() {
    core.SmoothScrollbar()
  },
  computed: {
    escuelaIdUser() {
      if (this.$store.getters.usuario.escuela_id == 4) {
        console.log("aaa" + this.$store.getters.usuario.escuela_id)
        return false;
      }
      if (this.$store.getters.usuario.escuela_id == 3) {
        console.log("bbb" + this.$store.getters.usuario.escuela_id)
        return false;
      }
      else {
        console.log("ccc" + "1")
        return true;
      }

    },

    showKnowMoreMenu() {
      return process.env.VUE_APP_SHOW_KNOW_MORE_MENU === 'true';
    },

    ...mapGetters({
      logo: 'darklogo',
      sidelogo: 'logo',
      isSidebarOpen: 'ui/isSidebarOpen'
    })
  },
  methods: {
    checkActive(route) {
      if (this.$route.name == route) {
        // console.log('this.$route.name'+ this.$route.name);
        return true;
      } else {
        return false;
      }
    },
    miniSidebar() {
      core.triggerSet()
    },
    toggleSidebar() {
      this.$store.commit('ui/toggleSidebar') // 👈 cambia el estado desde Vuex
    },
    showCollapse(collapseId) {
      document.getElementById(collapseId).closest('li').classList.add('active')
    },
    hideCollapse() {
      const list = document.querySelector('.iq-sidebar-menu').querySelectorAll('.submenu')
      Array.from(list, elem => {
        if (elem.closest('.active') !== null && elem.closest('.active') !== undefined) {
          elem.closest('.active').classList.remove('active')
        }
      })
    },
    async getMenu() {
      const url = `/api/menu/get-menu`;
      const response = await this.$api.get(url);

      let { menus } = response.data;

      this.resultSet = menus;
    }
  },

}
</script>

<style lang="css" scoped>
/* If the screen size is 601px wide or more, set the font-size of <div> to 80px */
@media screen and (min-width: 1367px) {
  .texto-logo-eleva {
    font-size: 22px;
  }

  .icono_espacio_izq {
    margin-left: 0.5rem !important;
  }
}

.header-logo img{
  max-width: 100px;
  height: auto;
}
</style>